import axios from "axios";
import { LoadPanel, Popup } from "devextreme-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../../../components/Logout";
import { Table2 } from "../../../../components/Table2/Table2";
import { Toster } from "../../../../components/Toster/Toster";
import { handleGetLocal } from "../../../../services/auth-service";
import { formatDateRange } from "../../../Dateapi/dateFormatter";
import { setrevocationsTableData } from "../Dockect/Data";
import { AddRevocationsPopup } from "../Dockect/Revocations/AddRevocationsPopup";
import { AddWarrentsPopup } from "../Dockect/Warrents/AddWarrentsPopup";
import UniqueCourts from "../Dockect/overview/UniqueCourts";
import { ChangeSupervisionDate } from "../GoToDocket/GoTODocketHeader";
import { GoToDocketHeaderFunction } from "../GoToDocket/GoToDocketHeaderFunction";
import { AddTollingPopup } from "./AddTollingPopup";
import ChangeFinancialStatus from "./ChangeFinancialStatus";
import ChangeSupervisor from "./ChangeSupervisor";

const Tablecoloum = [
  { title: "", moreoption: true, customwidth: "50px" },
  {
    title: "Select",
    DocketManagementSelect: true,
    bool: true,
  },
  { title: "Alerts" },
  {
    title: "Reference",
  },
  { title: "Docket/Count" },
  {
    title: "Count",
  },
  {
    title: "Offense",
  },
  {
    title: "Supervisor",
  },
  {
    title: "Supervisor Status",
  },
  {
    title: "Court Sentence",
    date: true,
  },
  {
    title: "Sentence Date Range",
    // date: true,
  },
  {
    title: "Days Tolled",
  },
  {
    title: "Balance",
    currency: true,
  },
  {
    title: "Docket Link",
  },
  {
    title: "Total Days",
  },
];

export const DocketManagement = ({ docketmanagement, userinfo, getDockrtManagement }) => {
  const [data, setdata] = useState([]);
  const [dockets, setDockets] = useState([]);
  const [selectedRowCheckbox, setSelectedRowCheckbox] = useState([]);

  const [ChangesuperviserDatePOpup, setChangesuperviserDatePOpup] = useState(false);
  const [changeFinancialStatusPopup, setChangeFinancialStatusPopup] = useState(false);
  const [changeSupervisorPopup, setChangeSupervisorPopup] = useState(false);
  const [addTollingPopup, setAddTollingPopup] = useState(false);

  const [SupervisionStatusdropdown, setSupervisionStatusdropdown] = useState([]);
  const [changeReasonDRopDown, setchangeReasonDRopDown] = useState([]);

  const [loading, setLoading] = useState(false);
  const [LocationdropDown, setLocationdropDown] = useState([]);
  const [TyperopDown, setTyperopDown] = useState([]);
  const [CourtropDown, setCourtropDown] = useState([]);
  const [JudgedropDown, setJudgedropDown] = useState([]);
  const [OffensedropDown, setOffensedropDown] = useState([]);
  const [AddRevocationspopup, setAddRevocationspopup] = useState(false);
  const [addWarrentsPopup, setAddWarrentsPopup] = useState(false);
  const [docketDropdownData, setDocketDropdownData] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [Revocationserrorhandlig, setRevocationserrorhandlig] = useState(false);
  const [countrevocations, setCountrevocations] = useState();
  const [revocationsgData, setrevocationsgData] = useState([]);
  const [reset, setReset] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  // const [uniqueCourtsOpen, setUniqueCourtsOpen] = useState(false);
  const [uniqueCourtsVisible, setUniqueCourtsVisible] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const pathname = handleGetLocal("pathURL");
  const navigate = useNavigate();
  const clas = new GoToDocketHeaderFunction(navigate);

  const getDocketDropdownData = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/docket/get-dockets?personId=${userinfo?.gPersonId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setDocketDropdownData(val?.data?.data);
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  const getDropdownDatas = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/docket/docket-dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setDropdownData(val?.data?.data);
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  const getRevocationsDataApi = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/revocation/get-revocations?personId=${userinfo?.gPersonId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        if (val?.data?.isSuccess) {
          setRevocationserrorhandlig(false);
          setCountrevocations(val?.data?.data?.length);
          setrevocationsgData(setrevocationsTableData(val?.data?.data));
        } else {
          setRevocationserrorhandlig(true);
        }
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        } else {
          setRevocationserrorhandlig(true);
        }
      });
  };

  useEffect(() => {
    clas.getDropDown(
      setLoading,
      setLocationdropDown,
      setTyperopDown,
      setCourtropDown,
      setJudgedropDown,
      setOffensedropDown,
      setSupervisionStatusdropdown,
      setchangeReasonDRopDown
    );
    getDocketDropdownData();
    getDropdownDatas();
  }, []);

  // useEffect(() => {
  //   // setDockets(data.filter((item) => selectedRowCheckbox.includes(item.ID)).map((item) => item.userinfo));
  //   const rows = data.filter((item) => selectedRowCheckbox.includes(item.ID));
  //   setSelectedRows(rows);
  //   setDockets(rows.map((item) => item.userinfo));
  // }, [selectedRowCheckbox]);
  useEffect(() => {
    const rows = data.filter((item) => selectedRowCheckbox.includes(item.ID));
    setSelectedRows(rows);
    setDockets(rows.map((item) => item.userinfo));
  }, [selectedRowCheckbox, data]);

  const handleAddWarrantsClick = () => {
  // only validate if multiple rows are selected
  if (selectedRows.length > 1) {
    // "Count" is your court name in setdata(...) mapping
    // fallback to userinfo.sCourtName just in case
    const courts = selectedRows
      .map(r => r?.Count ?? r?.userinfo?.sCourtName)
      .filter(Boolean);

    const uniqueCourts = new Set(courts);
    if (uniqueCourts.size > 1) {
      setUniqueCourtsVisible(true);   // show “Dockets must be in the same courts”
      return;                          // <-- stop here, don't open Warrants
    }
  }

  // all good: open Add Warrants popup
  setAddWarrentsPopup(true);
};

  // useEffect(() => {
  //   if (selectedRows.length <= 1) return;

  //   // Your "Count" column is actually the court name (see mapping below),
  //   // so we use Count to compare courts.
  //   const courts = Array.from(new Set(selectedRows.map((r) => r?.Count).filter(Boolean)));

  //   if (courts.length > 1) {
  //     // Show the popup
  //     setUniqueCourtsOpen(true);

  //     // Keep only rows from the first selected court (or pick any policy you prefer)
  //     const keepCourt = selectedRows[0]?.Count;
  //     setSelectedRowCheckbox((prev) =>
  //       prev.filter((id) => {
  //         const row = data.find((d) => d.ID === id);
  //         return row?.Count === keepCourt;
  //       })
  //     );
  //   }
  // }, [selectedRows, data]);

  useEffect(() => {
    setdata(
      docketmanagement?.map((val, i) => {
        return {
          Alerts: val?.sDocketAlert,
          Reference: val?.sReferenceNumber,
          "Docket/Count": val?.sDocketNumberCourtCounts,
          Count: val?.sCourtName,
          Offense: val?.sOffenseDescription,
          Supervisor: val?.sSupervisorNameLastFirst,
          "Supervisor Status": val?.sSupervisionStatusName,
          "Court Sentence": val?.dCourtSentence,
          "Sentence Date Range": formatDateRange(val?.sSentenceDateRange),
          "Days Tolled": val?.iSentence_AdditionalDays,
          Balance: val?.fBalance,
          "Docket Link": val?.sDocketLinkTypeName,
          "Total Days": val?.iSentence_TotalDays,
          sDocketNumberCourtCounts: val?.sDocketNumberCourtCounts,
          userinfo: val,
          ID: i,
        };
      })
    );
  }, [docketmanagement]);
  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <ChangeSupervisionDate
        ChangesuperviserDatePOpup={ChangesuperviserDatePOpup}
        setChangesuperviserDatePOpup={setChangesuperviserDatePOpup}
        data={dockets}
        SupervisionStatusdropdown={SupervisionStatusdropdown}
        changeReasonDRopDown={changeReasonDRopDown}
        toastConfig={toastConfig}
        setToastConfig={setToastConfig}
        getDcket={getDockrtManagement}
        refreshUserInfo={true}
      />
      <Popup
        visible={AddRevocationspopup}
        onHiding={() => {
          setReset(!reset);
          setAddRevocationspopup(false);
        }}
        showTitle={false}
        width={730}
        height={620}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <AddRevocationsPopup
          AddRevocationspopup={AddRevocationspopup}
          setAddRevocationspopup={setAddRevocationspopup}
          docketDropdownData={docketDropdownData}
          dropdownData={dropdownData}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          getRevocationsDataApi={getRevocationsDataApi}
          // dockertDetail={dockertDetail}
          setReset={setReset}
          reset={reset}
          // GoToRevocationDocketDisable={GoToRevocationDocketDisable}
          isMultiSelection={selectedRows.length > 1}
          selectedDocketIds={selectedRows.map((r) => r?.userinfo?.gDocketId).filter(Boolean)}
          selectedDocketRefs={selectedRows.map((r) => r?.["Docket/Count"]).filter(Boolean)}
        />
      </Popup>
      <UniqueCourts visible={uniqueCourtsVisible} onClose={() => setUniqueCourtsVisible(false)} />

      <Popup
        visible={addWarrentsPopup}
        onHiding={() => setAddWarrentsPopup(false)}
        showTitle={false}
        width={768}
        height={680}
        showCloseButton
        hideOnOutsideClick={false}
      >
        <AddWarrentsPopup
          addWarrentsPopup={addWarrentsPopup}
          setAddWarrentsPopup={setAddWarrentsPopup}
          dropdownData={dropdownData}
          docketDropdownData={docketDropdownData}
          rowWarrentData={null}
          warrantType="ADD"
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          getWarrantsDataApi={() => {}}
          setLoading={setLoading}
          loading={loading}
          userinfo={userinfo}
          gotoWarrents={false}
          dockertDetail={null}
          dockerHeaderData={null}
          isMultiSelection={selectedRows.length > 1}
          selectedDocketIds={selectedRows.map((r) => r?.userinfo?.gDocketId).filter(Boolean)}
          selectedDocketRefs={selectedRows.map((r) => r?.["Docket/Count"]).filter(Boolean)}
        />
      </Popup>

      <Popup
        visible={changeFinancialStatusPopup}
        onHiding={() => {
          setChangeFinancialStatusPopup(false);
        }}
        showTitle={false}
        width={750}
        height={590}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <ChangeFinancialStatus
          showModal={changeFinancialStatusPopup}
          setShowModal={setChangeFinancialStatusPopup}
          dockets={dockets}
          setToastConfig={setToastConfig}
          setLoading={setLoading}
        />
      </Popup>
      <Popup
        visible={changeSupervisorPopup}
        onHiding={() => {
          setChangeSupervisorPopup(false);
        }}
        showTitle={false}
        width={500}
        height={220}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <ChangeSupervisor
          dockets={dockets}
          showModal={changeSupervisorPopup}
          setShowModal={setChangeSupervisorPopup}
          setLoading={setLoading}
          setToastConfig={setToastConfig}
          reloadApi={getDockrtManagement}
        />
      </Popup>
      <Popup
        visible={addTollingPopup}
        onHiding={() => {
          setAddTollingPopup(false);
        }}
        showTitle={false}
        width={608}
        height={440}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <AddTollingPopup
          dockets={dockets}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          setAddTollingPopup={setAddTollingPopup}
        />
      </Popup>
      <div style={{ padding: "5px 15px 40px 15px" }}>
        <Table2
          Tablecoloum={Tablecoloum}
          tableRow={data}
          editTable={false}
          load={false}
          coloumWidthText={"DocketManagementTable"}
          height={"auto"}
          mandatoryColoum={"Docket/Count"}
          showTotalBlock={true}
          DocketManagementTotalshow={true}
          DocketManagementRightClick={true}
          selectedRowCheckbox={selectedRowCheckbox}
          setSelectedRowCheckbox={setSelectedRowCheckbox}
          setChangesuperviserDatePOpup={setChangesuperviserDatePOpup}
          setChangeFinancialStatusPopup={setChangeFinancialStatusPopup}
          setAddTollingPopup={setAddTollingPopup}
          setChangeSupervisorPopup={setChangeSupervisorPopup}
          setAddRevocationspopup={setAddRevocationspopup}
          setAddWarrentsPopup={handleAddWarrantsClick}
        />
      </div>
    </>
  );
};
